module.exports = __webpack_public_path__ + "static/media/chat.580689e7.svg";